// TargetGroup maps to top level categories, e.g. male, female and kids category.
export enum TargetGroup {
  UNSPECIFIED = 0,
  FEMALE = 1,
  MALE = 2,
  KIDS = 3,
}
